import { initApi } from "@/utils/api";
import { defineStore } from "pinia";
import { onBeforeMount } from "vue";
/*
export const useApiStoreCom = defineStore("api", () => {
  const baseURLRef = ref(import.meta.env.VITE_API_BASE_URL);
  const serverListRef = ref(["https://j7t.ru/api", "https://test1.j7t.ru/api"]);
  const baseURL = computed({
    get() {
      return baseURLRef.value; // Getter for reactive state
    },
    set(value) {
      baseURLRef.value = value; // Allow manual mutation
    },
  });
  const serverList = computed({
    get() {
      return serverListRef.value; // Getter for reactive state
    },
    set(value) {
      serverListRef.value = value; // Allow manual mutation
    },
  });
  return {
    baseURL,
    serverList,
  };
});
*/
const getDefault = () => ({
    serverList: [
        {
            id: 1,
            name: "statdbs.xyz",
            host: "statdbs.xyz",
            url: "https://statdbs.xyz/api",
        },
        {
            id: 2,
            name: "statdbs.server1",
            host: "statdbs.server1",
            url: "https://statdbs.server1/api",
        },
        {
            id: 3,
            name: "dev.statdbs.server1",
            host: "dev.statdbs.server1",
            url: "https://statdbs.server1/api",
        },
    ],
    currentServer: {
        id: 1,
        name: "statdbs.xyz",
        host: "statdbs.xyz",
        url: "https://statdbs.xyz/api",
    },
    //baseURL: "https://j7t.ru/api",
});

export const useApiStore = defineStore("api", {
    state: () => getDefault(),
    getters: {
        id: (state) => {
            return state.currentServer?.id ?? 1;
        },
        name: (state) => {
            return state.currentServer?.name ?? "statdbs.xyz";
        },
        baseURL: (state) => {
            return state.currentServer?.url;
        },
    },
    actions: {
        loadServerList() {},
        updateServerList(val) {
            this.serverList = val;
        },
        updateCurrentServer(val) {
            console.log("updateCurrentServer", val);
            this.currentServer = val;
            updateApi(this.baseURL);
        },
        changeServerById(id) {
            console.log("changeServer", id);
            let server = this.serverList.find((item) => {
                return item.id == id;
            });

            console.log("server", server);

            if (server) {
                this.currentServer = server;
            }
        },
        changeServerByHost(host) {
            console.log("changeServer on host", host);
            let server = this.serverList.find((item) => {
                return item.host == host;
            });

            if (server) {
                console.log("change Server to", server);
                this.currentServer = server;
            }
        },
    },
    persist: true,
});

export const initApiStore = () => {
    const apiStore = useApiStore();
    console.log("apiStore initApiStore", apiStore.baseURL);
    initApi(apiStore.baseURL);

    onBeforeMount(() => {
        console.log("apiStore mounted");

        let hostname = window.location.hostname;
        if (hostname) {
            apiStore.changeServerByHost(hostname);
        }
    });
};
